module.exports = "/_next/static/images/Avatar-40adb379db754dea6c929803c2a0a608.jpeg";